function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { FaCommentDots, FaBars } from 'react-icons/fa';
import { appActions } from '../../reducers/app.reducer';
import SubHeader from './SubHeader.react';
import SocialIcon from './SocialIcon.react';
var Header = function Header(_ref) {
  var toggleHamburgerMenuAction = _ref.toggleHamburgerMenuAction;
  var _window = window,
    pathname = _window.location.pathname;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEffect(function () {
    setVisible(pathname !== '/proof');
  }, [pathname]);
  if (!visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "header",
    id: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__logo",
    onClick: function onClick() {
      toggleHamburgerMenuAction(false);
    }
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: "/"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/logo/Posillico_P.png",
    className: "header__logo--desktop",
    alt: "Posillico Materials"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/logo/Posillico_Logo_mobile-hi.png",
    className: "header__logo--mobile",
    alt: "Posillico Materials"
  }))), /*#__PURE__*/React.createElement(NavLink, {
    to: "/"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/logo/Posillico-Materials-hi-noP.png",
    className: "header__materials",
    alt: "Posillico Materials",
    onClick: function onClick() {
      toggleHamburgerMenuAction(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__contact"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "mailto:materials@posillicoinc.com"
  }, "materials@posillicoinc.com")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "tel:+16313905777"
  }, "631.390.5777")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(SocialIcon, {
    media: "facebook"
  }), /*#__PURE__*/React.createElement(SocialIcon, {
    media: "linkedin"
  }), /*#__PURE__*/React.createElement(SocialIcon, {
    media: "instagram"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "header__toggle-mobile-menu",
    onClick: function onClick() {
      return toggleHamburgerMenuAction();
    }
  }, /*#__PURE__*/React.createElement(FaBars, null)), /*#__PURE__*/React.createElement("div", {
    className: "header__mobile-contact-info"
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: "/contact-us"
  }, /*#__PURE__*/React.createElement(FaCommentDots, null))), /*#__PURE__*/React.createElement("div", {
    className: "header__border"
  }), /*#__PURE__*/React.createElement(SubHeader, null));
};
var mdtp = {
  toggleHamburgerMenuAction: appActions.toggleHamburgerMenu
};
export default connect(null, mdtp)(Header);